import { NonBFIExperienceActionType } from '../ExperienceConstants';
import store, { experienceActions } from '@apply/adminStore';
import { ExperienceApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { handleAdminSuccess, handleAdminError } from '../../../common/SharedFunctions';
import { RefreshEvents } from '@apply/ui';

export const executeNonBFIExperienceAction = (itemData: { id?: number; experienceId: number; principalId: number }) => {
    const experienceApi = new ExperienceApi.ExperienceApi(applicationInsights);
    const { dispatch } = store;
    const refreshEvents = new RefreshEvents();

    const onAddNonBfi = (principalId) => {
        dispatch(
            experienceActions.setNonBfiDetailModal({
                nonBfiDetailModal: { isOpen: true, id: 0, principalId },
            })
        );
    };

    const onModifyNonBfi = (id) => {
        dispatch(
            experienceActions.setNonBfiDetailModal({
                nonBfiDetailModal: { isOpen: true, id },
            })
        );
    };

    const onDeleteNonBfi = async (id) => {
        try {
            await experienceApi.deleteExperienceNonBfi(id);
            handleAdminSuccess('The experience has been deleted successfully');
            refreshEvents.dispatchRefreshEvent();
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred! Please try again.');
        }
    };

    const onAuditHistory = (id) => {
        dispatch(
            experienceActions.setAuditHistoryModal({
                auditHistoryModal: { isOpen: true, id },
            })
        );
    };

    const onNotImplemented = () => {
        alert('Not Implemented yet!');
    };

    switch (itemData.id) {
        case NonBFIExperienceActionType.AddNonBfi:
            onAddNonBfi(itemData.principalId);
            break;
        case NonBFIExperienceActionType.ModifyNonBfi:
            onModifyNonBfi(itemData.experienceId);
            break;
        case NonBFIExperienceActionType.DeleteNonBfi:
            onDeleteNonBfi(itemData.experienceId);
            break;
        case NonBFIExperienceActionType.AuditHistory:
            onAuditHistory(itemData.experienceId);
            break;
        default:
            onNotImplemented();
            break;
    }
};
